import Image from './_image.js'
import Text from './_text.js'
import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Spinner from './_spinner.js'
import ConfigurablePane from './_configurable-pane.js'

export default {
  name: 'ToggleButton',
  values: {
    activeImage: {
      configSet: Image,
      configValues: {
        src: 'check',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
    activeLabel: {
      configSet: Text,
      configValues: {},
    },
    inactiveLabel: {
      configSet: Text,
      configValues: {},
    },
    disabledLabel: {
      configSet: Text,
      configValues: {},
    },
    button: {
      configSet: Button,
      configValues: {},
    },
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    inactiveImage: {
      configSet: Image,
      configValues: {
        src: 'cross-thin',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {},
    },
    showSpinnerDelay: 500,
    style: {
      base: {
        container: {
          width: '48px',
          minWidth: '48px',
          maxHeight: '24px',
          cursor: 'pointer',
          transition: 'opacity 0.2s',
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        face: {
          top: '0.1em',
          left: '0.1em',
          right: '0.1em',
          bottom: '0.1em',
          transition: undefined,
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        switch: {
          width: '24px',
          height: '24px',
          transition: 'background-color 0.2s, right 0.2s, transform 0.2s',
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
      },
      active: {
        container: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        face: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        switch: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
      },
      inactive: {
        container: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        face: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        switch: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
      },
      disabled: {
        container: {
          opacity: 0.5,
          cursor: 'auto',
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        face: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
        switch: {
          $mixin: [
            {
              configSet: ConfigurablePane,
            },
          ],
        },
      },
      imageContainer: {
        transition: 'opacity 0.2s',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
